module.exports = __webpack_public_path__ + "img/ellipse.f5e2b80b.svg";